var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "76px",
    viewBox: "0 0 90 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "77.1758805%",
    cy: "25.7379553%",
    fx: "77.1758805%",
    fy: "25.7379553%",
    r: "91.1819884%",
    gradientTransform: "translate(0.771759,0.257380),scale(1.000000,0.853213),rotate(107.339919),translate(-0.771759,-0.257380)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.89743889e-07%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084C8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1572CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(-1445.000000, -3772.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(1445.500000, 3772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8310212,13.9674398 L33.1153418,0.148959809 C32.6740104,-0.0496532695 32.1702017,-0.0496532695 31.7288702,0.148959809 L1.01319084,13.9674398 C0.397061562,14.2447174 0,14.8632398 0,15.5457693 L0,33.1816044 C0,50.9836932 10.348411,67.1086718 26.3642915,74.2591954 C28.9873891,75.4305275 30.9689771,76 32.422106,76 C33.8752349,76 35.8568229,75.4305275 38.4799206,74.2591954 C54.4958011,67.1070524 64.8442121,50.9820737 64.8442121,33.1816044 L64.8442121,15.5457693 C64.8442121,14.8632398 64.4471505,14.2447174 63.8310212,13.9674398 L63.8310212,13.9674398 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4271017,13.9674398 L57.7114223,0.148959809 C57.2700908,-0.0496532695 56.7662821,-0.0496532695 56.3249507,0.148959809 L25.6092713,13.9674398 C24.993142,14.2447174 24.5960804,14.8632398 24.5960804,15.5457693 L24.5960804,33.1816044 C24.5960804,50.9836932 34.9444914,67.1086718 50.9603719,74.2591954 C53.5834696,75.4305275 55.5650576,76 57.0181864,76 C58.4713153,76 60.4529033,75.4305275 63.076001,74.2591954 C79.0918815,67.1070524 89.4402925,50.9820737 89.4402925,33.1816044 L89.4402925,15.5457693 C89.4402925,14.8632398 89.043231,14.2447174 88.4271017,13.9674398 L88.4271017,13.9674398 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature-2.53aa367d0d24e8aa60d8f7ea9805b8bb.svg";
export { ForwardRef as ReactComponent };